import Cookies from "js-cookie";
import md5 from 'md5';
import { navigate } from "gatsby";

const CookieDomains = [
  'localhost',
  '.hexowatch.com',
];

// TODO: REMOVE THIS!!!!!!!!
// TMP FIX FOR COOKIES
setTimeout(() => {
  // @ts-ignore
  if (global.window && global.window.location && global.window.location.hostname && global.window.location.hostname.indexOf('hexowatch.com') > -1) {
    Cookies.remove("__session", {
      domain: undefined,
    });
  }
}, 100);

export const getRawCookie = (name: string): string | undefined => Cookies.get(name);

export const getCookies = (): any => {
  let cookiesStr: string | undefined = undefined;
  let cookies = {};
  for (let domain of CookieDomains) {
    cookiesStr = Cookies.get("__session", {domain: domain});
    if (cookiesStr) {
      try {
        cookies = JSON.parse(decodeURIComponent(cookiesStr));
      } catch (e) {}
    }
  }

  return cookies;
}

export const setCookie = (key: string, value: string | null) => {
  CookieDomains.map(domain => {
    Cookies.set("__session", JSON.stringify({ ...getCookies(), [key]: value }), {
      expires: 30,
      domain: domain,
    });
  });
};
export const getCookie = (key: string): string => getCookies()[key]
export const removeCookie = (key: string) => {
  const cookies = getCookies();
  delete cookies[key];
  CookieDomains.map(domain => {
    Cookies.remove("__session", {
      expires: 30,
      domain: domain,
    });
  });
};

export const setCookieDownloadIgnore = () => setCookie('download-panel', 'closed');
export const getCookieDownloadIgnore = () => getCookie("download-panel");

export const setCaptchaResponseToken = (token: string) =>
  // @ts-ignore
  global.window &&
  sessionStorage && sessionStorage.setItem("toolsCaptchaResponseToken", token)

export const getCaptchaResponseToken = () =>
  // @ts-ignore
  global.window &&
  sessionStorage && sessionStorage.getItem("toolsCaptchaResponseToken")

export const deleteCaptchaResponseToken = () =>
  // @ts-ignore
  global.window &&
  sessionStorage && sessionStorage.removeItem("toolsCaptchaResponseToken")

export const setToolsToken = (token: string) =>
  // @ts-ignore
  global.window &&
  sessionStorage && sessionStorage.setItem("toolsSessionToken", token)

export const getToolsToken = () =>
  // @ts-ignore
  global.window &&
  sessionStorage && sessionStorage.getItem("toolsSessionToken")

export const deleteToolsToken = () =>
  // @ts-ignore
  global.window &&
  sessionStorage && sessionStorage.removeItem("toolsSessionToken")

export const setUserToken = (token: string) => setCookie("user-token", token);
export const setUserHash = (hash: string) => setCookie("user-hash", hash);
export const getUserToken = (): string | undefined => getCookie("user-token");
export const getUserHash = (): string | undefined => getCookie("user-hash");
export const removeUserToken = () => setCookie("user-token", null);
export const removeUserHash = () => setCookie("user-hash", null);

export const setUserEmail = (email: string) => setCookie("user-email", email);
export const getUserEmail = (): string | undefined => getCookie("user-email");
export const removeUserEmail = () => setCookie("user-email", null);

export const setUserName = (name: string) => setCookie("user-name", name);
export const getUserName = (): string | undefined => getCookie("user-name");
export const removeUserName = () => setCookie("user-name", null);

export const setCookiePolicy = () => setCookie('user', 'registered');
// @ts-ignore
export const getCookiePolicy = () => !global.window ? 'registered' : getCookie('user');

export const getGravatar = (email: string, size?: number) => {
  size = size || 80
  return "https://www.gravatar.com/avatar/" + md5(email) + ".jpg?s=" + size + "&d=monsterid";
}

export const toggleLastURL = () => {
  if (window.history.length === 1) {
    navigate('/');
  } else {
    console.log('going back');

    window.history.back();
  }
};

export const toggleCloseLoginModalURL = () => {
  navigate('/');
};

export const gotToWithReplace = (pathName: string) => {
  window.history.replaceState({}, '', pathName);
  if(pathName === '/login') {
    navigate(pathName, {state: {goBack: true}});
  } else {
      navigate(pathName);
  }
};
